var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminpanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.302,
    height: 20.586,
    viewBox: "0 0 20.302 20.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.357,
    cy: 4.586,
    rx: 4.357,
    ry: 4.586,
    transform: "translate(3.547 0)",
    fill: "#697384"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.27,19.835a2.232,2.232,0,0,1,.181-2.493,2.232,2.232,0,0,1-.181-2.493l.72-1.247a2.233,2.233,0,0,1,1.929-1.113,2.267,2.267,0,0,1,.321.023,2.312,2.312,0,0,1,.1-.211A4.2,4.2,0,0,0,11.8,12H4.229A4.234,4.234,0,0,0,0,16.229v3.116a.668.668,0,0,0,.668.668h9.7Z",
    transform: "translate(0 -1.208)",
    fill: "#697384"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.771,17.869a3.236,3.236,0,0,0,.042-.418,3.384,3.384,0,0,0-.042-.418l.8-.607a.445.445,0,0,0,.117-.578l-.72-1.247a.445.445,0,0,0-.558-.188l-.923.389a3.308,3.308,0,0,0-.729-.434l-.123-.98a.446.446,0,0,0-.442-.39h-1.44a.445.445,0,0,0-.442.39l-.123.98a3.322,3.322,0,0,0-.729.434l-.923-.389a.444.444,0,0,0-.558.188l-.72,1.247a.446.446,0,0,0,.117.578l.8.607a3.236,3.236,0,0,0-.042.418,3.384,3.384,0,0,0,.042.418l-.8.607a.445.445,0,0,0-.117.578l.72,1.247a.445.445,0,0,0,.558.188l.923-.39a3.308,3.308,0,0,0,.729.434l.123.98a.444.444,0,0,0,.441.39h1.44a.445.445,0,0,0,.442-.39l.123-.98a3.322,3.322,0,0,0,.729-.434l.923.389a.444.444,0,0,0,.558-.188l.72-1.247a.446.446,0,0,0-.117-.578Zm-3.3,1.363a1.781,1.781,0,1,1,1.781-1.781A1.78,1.78,0,0,1,17.474,19.233Z",
    transform: "translate(-1.447 -1.317)",
    fill: "#697384"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminpanel);
export default __webpack_public_path__ + "static/media/adminpanel.6ae7f419adbfbcbdb08dba7b1dd5671c.svg";
export { ForwardRef as ReactComponent };